/**
 * Pure logic helpers for InstallBanner. Extracted so they can be unit-tested
 * without spinning up a React renderer (jsdom + RTL has a React-copy mismatch
 * issue in this monorepo layout).
 *
 * The component imports these and wires them to handlers / effects.
 */

export const INSTALL_SOURCE_KEY = 'tm.pwa.installSource';

export function platformLabel({ ios, android }) {
  if (ios) return 'ios';
  if (android) return 'android';
  return 'other';
}

/**
 * Decide what should happen when the user clicks the CTA. Returns an
 * action object the caller dispatches — keeps the side-effects (capture,
 * triggerPrompt, openModal) out of this module so it stays pure.
 *
 * Inputs are an explicit context object so tests can drive every branch
 * with plain JS.
 */
export function decideCtaAction(ctx) {
  const { iosSafari, ios, hasNativePrompt } = ctx;
  if (iosSafari || ios) {
    return { type: 'open_ios_modal' };
  }
  if (hasNativePrompt) {
    return { type: 'trigger_native_prompt' };
  }
  return { type: 'no_prompt_available' };
}

export function buildShownProps({ reason, snapshot, platform }) {
  return {
    reason,
    visitCount: snapshot.visitCount,
    platform,
  };
}

export function buildDismissProps({ snapshot }) {
  return {
    visitCount: snapshot.visitCount,
    daysSinceFirstVisit: snapshot.daysSinceFirstVisit,
    dismissCount: snapshot.dismissCount + 1,
  };
}

export function buildCtaProps({ platform, hasNativePrompt, installContext }) {
  return {
    platform,
    hasNativePrompt,
    ...installContext,
  };
}

export function writeInstallSource(value, sessionStorageRef) {
  try {
    const ss = sessionStorageRef ?? (typeof sessionStorage !== 'undefined' ? sessionStorage : null);
    if (!ss) return;
    ss.setItem(INSTALL_SOURCE_KEY, value);
  } catch { /* ignore */ }
}
